const validators = {};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/validators/action-validators.js